import styled from 'styled-components'
import Box from '../layout/Box'

const FocusTrap = styled(Box).attrs(({as = 'div'}) => ({
  tabIndex: -1,
  as,
  className: 'focus-trap',
}))`
  display: inherit;
  outline: none;
`

FocusTrap.displayName = 'FocusTrap'

export default FocusTrap
